import React, { useState, useEffect } from 'react';
import './App.css';
import Scene from './components/Scene';
import EntryModal from './components/EntryModal';

function App() {
  const [isMobile, setIsMobile] = useState(false)
  const [showModal, setShowModal] = useState(true)

  // Detect mobile device
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768)
    }
    
    checkMobile()
    window.addEventListener('resize', checkMobile)
    
    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  const handleEnterCult = () => {
    setShowModal(false)
  }

  return (
    <div className="App">
      <EntryModal 
        isVisible={showModal} 
        onEnter={handleEnterCult} 
      />
      
      {/* Scene - conditionally rendered to avoid any initialization glitches */}
      {!showModal && (
        <div 
          style={{ 
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 1
          }}
        >
          <Scene />
        </div>
      )}

      {/* UI Elements - hidden while modal is visible */}
      <div style={{ 
        opacity: showModal ? 0 : 1,
        transition: 'opacity 0.5s ease-in-out',
        pointerEvents: showModal ? 'none' : 'auto'
      }}>
        <div style={{ 
          position: 'absolute',
          top: '20px',
          left: isMobile ? '50%' : '40px',
          transform: isMobile ? 'translateX(-50%)' : 'none',
          zIndex: 100,
          color: 'rgb(255, 237, 253)',
          fontSize: '1.2rem',
          fontWeight: 900,
          textShadow: 'rgba(0, 0, 0, 0.5) 2px 2px 4px',
          fontStyle: 'italic',
          backgroundColor:'transparent !important'
        }}>
        $RARECOIN
      </div>
      
      {/* Contract Address */}
      <div 
        onClick={() => {
          navigator.clipboard.writeText('GWaD6wcxSZFwXApoY56x6Cxiqs5sAvtQNdcUvz7Zbonk')
          // Optional: Show a brief "Copied!" message
          const originalText = document.getElementById('contract-address').textContent
          document.getElementById('contract-address').textContent = 'Copied!'
          setTimeout(() => {
            document.getElementById('contract-address').textContent = originalText
          }, 1000)
        }}
        style={{
          position: 'absolute',
          bottom: isMobile ? '160px' : '80px',
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 100,
          color: '#f0f0f0',
          fontSize: isMobile ? '0.8rem' : '0.9rem',
          fontWeight: 400,
          fontFamily: 'monospace',
          textShadow: 'rgba(0, 0, 0, 0.5) 1px 1px 2px',
          cursor: 'pointer',
          padding: '8px 12px',
          transition: 'all 0.3s ease',
          textAlign: 'center',
          userSelect: 'none'
        }}
        id="contract-address"
        title="Click to copy contract address"
      >
        GWaD6wcxSZFwXApoY56x6Cxiqs5sAvtQNdcUvz7Zbonk
      </div>
      
      {/* Footer Links */}
      <div style={{
        position: 'absolute',
        bottom: '20px',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 100,
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        gap: isMobile ? '15px' : '30px',
        alignItems: 'center',
        textAlign: 'center',
         backgroundColor:'transparent !important'
      }}>
        {/* X Community */}
        <a 
          id="social-link-community"
          href="https://x.com/i/communities/1971313695650107868" 
          target="_blank" 
          rel="noopener noreferrer"
          style={{
            color: '#f0f0f0',
            textDecoration: 'none',
            fontSize: '1rem',
            fontWeight: 400,
            textShadow: 'rgba(0, 0, 0, 0.5) 1px 1px 2px',
            transition: 'all 0.3s ease',
            backgroundColor: 'transparent !important',
            background: 'transparent !important'
          }}
          onMouseEnter={(e) => {
            e.target.style.color = '#ffffff';
            e.target.style.transform = 'scale(1.1)';
          }}
          onMouseLeave={(e) => {
            e.target.style.color = '#f0f0f0';
            e.target.style.transform = 'scale(1)';
          }}
        >
          X Community
        </a>
        
        {/* X Page */}
        <a 
          id="social-link-page"
          href="https://x.com/rarecoinonsol" 
          target="_blank" 
          rel="noopener noreferrer"
          style={{
            color: '#f0f0f0',
            textDecoration: 'none',
            fontSize: '1rem',
            fontWeight: 400,
            textShadow: 'rgba(0, 0, 0, 0.5) 1px 1px 2px',
            transition: 'all 0.3s ease',
            backgroundColor: 'transparent',
            background: 'transparent'
          }}
          onMouseEnter={(e) => {
            e.target.style.color = '#ffffff';
            e.target.style.transform = 'scale(1.1)';
          }}
          onMouseLeave={(e) => {
            e.target.style.color = '#f0f0f0';
            e.target.style.transform = 'scale(1)';
          }}
        >
          X Page
        </a>
        
        {/* DexScreener */}
        <a 
          id="social-link-dexscreener"
          href="https://dexscreener.com/solana/48hfmdnyynuat6r2tdtp2ljan3rcpoypai3pakvzefte" 
          target="_blank" 
          rel="noopener noreferrer"
          style={{
            color: '#f0f0f0',
            textDecoration: 'none',
            fontSize: '1rem',
            fontWeight: 400,
            textShadow: 'rgba(0, 0, 0, 0.5) 1px 1px 2px',
            transition: 'all 0.3s ease',
            backgroundColor: 'transparent',
            background: 'transparent'
          }}
          onMouseEnter={(e) => {
            e.target.style.color = '#ffffff';
            e.target.style.transform = 'scale(1.1)';
          }}
          onMouseLeave={(e) => {
            e.target.style.color = '#f0f0f0';
            e.target.style.transform = 'scale(1)';
          }}
        >
          DexScreener
        </a>
        
        {/* TikTok */}
        <a 
          id="social-link-tiktok"
          href="https://www.tiktok.com/@rarecoinsolana?_t=ZN-907EoWT4Ba2&_r=1" 
          target="_blank" 
          rel="noopener noreferrer"
          style={{
            color: '#f0f0f0',
            textDecoration: 'none',
            fontSize: '1rem',
            fontWeight: 400,
            textShadow: 'rgba(0, 0, 0, 0.5) 1px 1px 2px',
            transition: 'all 0.3s ease',
            backgroundColor: 'transparent',
            background: 'transparent'
          }}
          onMouseEnter={(e) => {
            e.target.style.color = '#ffffff';
            e.target.style.transform = 'scale(1.1)';
          }}
          onMouseLeave={(e) => {
            e.target.style.color = '#f0f0f0';
            e.target.style.transform = 'scale(1)';
          }}
        >
          TikTok
        </a>
        </div>
      </div>
    </div>
  );
}

export default App;
